import axios from '../utils/axios';

export function getUnmappedActiveRecruiters(adminId, params) {
    return axios.get(`/admin/${adminId}/unmapped-active-recruiters`, { params });
};
